import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static classes = ["hidden"]

  static values = {
    price: Number,
    saved: Boolean,
    year: String,
    country: String
  }

  static targets = ["checkbox", "discount", "discountGroup", "discountedPrice", "discountedPriceGroup", "service"]

  // outlet API: called by admin--quotes--marketing-package via the marketing service outlet
  // Offers the service for an auction in its year and an agency in its country, and keeps a service the quote already
  // has whatever the year and country. A service not offered is unticked and its fields left out of the form, so the
  // quote does not take it.
  showFor(year, country) {
    const shown = this.savedValue || (this.yearValue === year && this.countryValue === country)
    this.element.hidden = !shown
    this.serviceTarget.disabled = !shown
    this.discountTarget.disabled = !shown

    if (!shown && this.checkboxTarget.checked) {
      this.checkboxTarget.checked = false
      this.toggle()
    }
  }

  toggle() {
    const hideDiscount = !this.checkboxTarget.checked
    this.discountGroupTarget.classList.toggle(this.hiddenClass, hideDiscount)
    this.discountedPriceGroupTarget.classList.toggle(this.hiddenClass, hideDiscount)
  }

  updateDiscountedPrice() {
    this.discountedPriceTarget.innerText = (this.priceValue - this.#discount).toLocaleString()
  }

  get #discount() {
    return parseFloat(this.discountTarget.value) || 0
  }
}
